import axios, { AxiosResponse } from 'axios';
import { IGalleryApiResponse } from '../types/api/galleryApi';

const API_URL = process.env.REACT_APP_API_URL;

const customHeaders = {
    'Content-Type': 'application/json'
};

// Sign in function with typed parameters and response
export const getGalleryDataService = async (): Promise<AxiosResponse<IGalleryApiResponse>> => {
    try {
        const response = await axios.get(API_URL + 'roomGallery', { headers: customHeaders });
        return response;
    } catch (error: any) {
        console.error('Error fetching auth:', error);
        // You can toast an error message if needed
        // toast.error(error?.response?.data?.msg);
        throw error;
    }
};

